import {
  Directive,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  SimpleChanges
} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import tippy, {followCursor, Instance, Placement} from 'tippy.js';

@Directive({standalone: true, selector: '[twTippy]'})
export class TippyTooltipDirective implements OnInit, OnChanges, OnDestroy {
  @Input('twTippy') content: string | undefined;
  @Input() twTippyPlacement: Placement = 'top-start';
  @Input() twTippyAllowHTML: boolean = false;
  @Input() twTippyFollowCursor: boolean = true;
  @Input() twTippyMaxWidth: number = 480;
  @Input() twTippyDelay: number | [number, number] = [800, 0];
  @Input() twTippyTheme: string = 'tw';
  @Input() twTippyDisable: boolean = false;

  private instance?: Instance;

  constructor(private el: ElementRef<HTMLElement>, @Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.instance = tippy(this.el.nativeElement, {
      content: this.content ?? '',
      delay: this.twTippyDelay,
      allowHTML: this.twTippyAllowHTML,
      placement: this.twTippyPlacement,
      maxWidth: this.twTippyMaxWidth,
      theme: this.twTippyTheme,
      plugins: this.twTippyFollowCursor ? [followCursor] : undefined,
      followCursor: this.twTippyFollowCursor,
      // keep it lightweight; we just need hover tooltips
      interactive: false,
      appendTo: document.body
    });
    if (this.twTippyDisable) this.instance.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.instance) return;
    if (changes.content && !changes.content.firstChange) {
      this.instance.setContent(this.content ?? '');
    }
    if (changes.twTippyPlacement && !changes.twTippyPlacement.firstChange) {
      this.instance.setProps({placement: this.twTippyPlacement});
    }
    if (changes.twTippyAllowHTML && !changes.twTippyAllowHTML.firstChange) {
      this.instance.setProps({allowHTML: this.twTippyAllowHTML});
    }
    if (changes.twTippyFollowCursor && !changes.twTippyFollowCursor.firstChange) {
      this.instance.setProps({
        plugins: this.twTippyFollowCursor ? [followCursor] : undefined,
        followCursor: this.twTippyFollowCursor
      });
    }
    if (changes.twTippyMaxWidth && !changes.twTippyMaxWidth.firstChange) {
      this.instance.setProps({maxWidth: this.twTippyMaxWidth});
    }
    if (changes.twTippyTheme && !changes.twTippyTheme.firstChange) {
      this.instance.setProps({theme: this.twTippyTheme});
    }
  }

  ngOnDestroy(): void {
    this.instance?.destroy();
  }
}
